/**
 * PDP Variant Selector — handles option radio/swatch clicks
 * Reads product variants JSON, finds matching variant on option change,
 * updates hidden input, price, URL, and selected label.
 */
(function () {
  'use strict';

  function initVariantSelector(section) {
    if (!section || section.dataset.variantSelectorInit === 'done') return;
    section.dataset.variantSelectorInit = 'done';

    // Find variants JSON within the section
    var jsonEl = null;
    var scripts = section.querySelectorAll('script[type="application/json"]');
    scripts.forEach(function (s) {
      for (var key in s.dataset) {
        if (key.startsWith('productVariants')) {
          jsonEl = s;
        }
      }
    });

    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || variants.length === 0) return;

    var variantSelector = section.querySelector('variant-set-option');
    if (!variantSelector) return;

    var form = section.querySelector('.main-product-form');
    var variantInput = form ? form.querySelector('.product-variant-id') : null;
    var priceList = section.querySelector('.product-price-list');
    var atcButton = section.querySelector('.atc-button');
    var atcPriceEl = section.querySelector('.product-price-main');
    var atcTextEl = section.querySelector('.button-text');
    var addToCartSpan = section.querySelector('[data-add-to-cart-text]');

    // Get all radio inputs
    var radios = variantSelector.querySelectorAll('.product-swatch-option');

    function getSelectedOptions() {
      var fieldsets = variantSelector.querySelectorAll('fieldset');
      var options = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('.product-swatch-option:checked');
        if (checked) {
          options.push(checked.value);
        }
      });
      return options;
    }

    function findVariant(selectedOptions) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v['option' + (j + 1)] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(selectedOptions);

      if (!variant) return;

      // Update hidden form input
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.disabled = !variant.available;
      }

      // Update price display (DOM methods to avoid innerHTML XSS)
      if (priceList) {
        var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceList.textContent = '';
        var salePrice = document.createElement('product-sale-price');
        salePrice.className = 'product-price-actual';
        var priceSpan = document.createElement('span');
        priceSpan.className = 'product-actual-price' + (isOnSale ? ' on-sale' : '');
        priceSpan.textContent = formatMoney(variant.price);
        salePrice.appendChild(priceSpan);
        if (isOnSale) {
          var compareSmall = document.createElement('small');
          compareSmall.className = 'product-compare-price';
          compareSmall.textContent = formatMoney(variant.compare_at_price);
          salePrice.appendChild(compareSmall);
        }
        priceList.appendChild(salePrice);
      }

      // Update ATC button price
      if (atcPriceEl) {
        atcPriceEl.textContent = formatMoney(variant.price);
      }

      // Update ATC button state
      if (atcButton) {
        atcButton.disabled = !variant.available;
        if (atcTextEl) {
          if (!variant.available) {
            atcTextEl.textContent = 'Sold out';
          } else {
            atcTextEl.textContent = 'Add to cart';
          }
        }
      }

      // Update SKU
      var skuEls = section.querySelectorAll('[data-variant-sku]');
      skuEls.forEach(function (el) {
        el.textContent = variant.sku || '';
        var wrapper = el.closest('.product-sku, .product-accordion-sku');
        if (wrapper) {
          wrapper.hidden = !variant.sku;
        }
      });

      // Update selected value labels
      var fieldsets = variantSelector.querySelectorAll('fieldset');
      fieldsets.forEach(function (fs, idx) {
        var checked = fs.querySelector('.product-swatch-option:checked');
        if (checked) {
          var label = fs.querySelector('[data-slected-value]');
          if (label) {
            var formatted = checked.value.split(' ').map(function (w) {
              return w.length > 3 ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w;
            }).join(' ');
            label.textContent = formatted;
            label.dataset.optionName = label.dataset.typeName + ' / ' + checked.value;
          }
        }
      });

      // Update option availability (disable sold-out options)
      fieldsets = variantSelector.querySelectorAll('fieldset');
      fieldsets.forEach(function (fs, fsIdx) {
        var allRadios = fs.querySelectorAll('.product-swatch-option');
        allRadios.forEach(function (r) {
          var testOptions = getSelectedOptions();
          testOptions[fsIdx] = r.value;
          var anyAvailable = false;
          for (var vi = 0; vi < variants.length; vi++) {
            var v = variants[vi];
            var match = true;
            for (var oi = 0; oi < testOptions.length; oi++) {
              if (oi === fsIdx) {
                if (v['option' + (oi + 1)] !== r.value) { match = false; break; }
              } else {
                if (v['option' + (oi + 1)] !== testOptions[oi]) { match = false; break; }
              }
            }
            if (match && v.available) { anyAvailable = true; break; }
          }
          r.disabled = !anyAvailable;
        });
      });

      // Update URL without reload
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      // Update installment form hidden input
      var installmentInput = section.querySelector('form.text-small input[name="id"]');
      if (installmentInput) {
        installmentInput.value = variant.id;
      }
    }

    // Listen for changes on all radio inputs
    radios.forEach(function (radio) {
      radio.addEventListener('change', updateVariant);
    });

    // Also handle click on swatch-variant-item spans (for better UX)
    var swatchItems = variantSelector.querySelectorAll('.swatch-variant-item');
    swatchItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var radio = this.previousElementSibling;
        if (radio && radio.classList.contains('product-swatch-option') && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.main-product-section, .featured-product-section');
    sections.forEach(initVariantSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    setTimeout(initAll, 150);
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 250);
  });
})();
